import React, { useState, useEffect } from "react";
import "../css/AddEmployeeForm.css";
import { BASE_URL } from "../config";
import axios from "../axiosConfig";
import { getAuthHeaders } from "../services/useAuth";
import { ToastContainer, toast } from "react-toastify";
import Toaster, { showSuccessToast, showErrorToast } from "../dist/Toaster";
import errormessage from "../css/errormessage.css";
import CustomButton from "../pages/CustomButton";
const AddEmployeeForm = () => {
  const initialFormState = {
    username: "",
    firstName: "",
    lastName: "",
    fatherName: "",
    division: "",
    manager: "",
    state: "",
    dob: "",
    marriageAnniversary: "",
    gender: "Male",
    department: "SALES",
    country: "INDIA",
    city: "",
    mobile: "",
    headQuarter: "",
    trainingDate: "",
    confirmDate: "",
    finalJoiningDate: "",
    designation: "",
    subState: "",
    address: "",
    pin: "",
    email: "",
    remarks: "",
    residentialState: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({
    username: "",
    firstName: "",
    lastName: "",
    fatherName: "",
    dob: "",
    mobile: "",
    email: "",
    pin: "",
  });

  // State for dropdown options
  const [divisions, setDivisions] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [headquarters, setHeadquarters] = useState([]);
  const [subStates, setSubStates] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [residentialStates, setResidentialStates] = useState([]);
  const [managers, setManagers] = useState([]);
  const [existingUsernames, setExistingUsernames] = useState([]);
  const [existingMobiles, setExistingMobiles] = useState([]);
  const existingEmails = ["test@example.com", "user@example.com"];
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const results = await Promise.allSettled([
          axios.get(`${BASE_URL}/api/divisions`),
          axios.get(`${BASE_URL}/api/designations/`),
          axios.get(`${BASE_URL}/api/employees`),
          axios.get(`${BASE_URL}/api/states`, { headers: getAuthHeaders() }),
          axios.get(`${BASE_URL}/api/all-state`, { headers: getAuthHeaders() }),
        ]);
        const [
          divisionsRes,
          designationsRes,
          employeesRes,
          statesRes,
          residentialStatesRes,
        ] = results;
        if (divisionsRes.status === "fulfilled") {
          setDivisions(divisionsRes.value.data);
        }
        if (designationsRes.status === "fulfilled") {
          setDesignations(designationsRes.value.data);
        }
        if (employeesRes.status === "fulfilled") {
          const empData = employeesRes.value.data;
          setEmployees(empData);
          const usernames = empData.map((emp) => emp.employee);
          const mobiles = empData.map((emp) => emp.mobile).filter(Boolean);
          setExistingUsernames(usernames);
          setExistingMobiles(mobiles);
        } else {
          console.error("Employees API failed:", employeesRes.reason);
        }
        if (statesRes.status === "fulfilled") {
          setStates(statesRes.value.data);
        }
        if (residentialStatesRes.status === "fulfilled") {
          setResidentialStates(residentialStatesRes.value.data);
        }
      } catch (error) {
        console.error("Unexpected error:", error);
        toast.error("Something went wrong while loading data");
      }
    };

    fetchData();
  }, []);
  const getEighteenYearsAgo = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 18);
    return today.toISOString().split("T")[0];
  };
  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "username":
        if (!value) {
          error = "Username is required";
        } else if (
          value !== formData.username &&
          existingUsernames.includes(value)
        ) {
          error = "Username already exists";
        }
        break;
      case "firstName":
      case "lastName":
        if (name === "firstName" && !value) {
          error = "First name is required";
        } else if (value && !/^[A-Za-z\s.]*$/.test(value)) {
          error = "Only alphabets, spaces and dot (.) allowed";
        }
        break;
      case "fatherName":
        if (value && !/^[A-Za-z\s.]*$/.test(value)) {
          error = "Only alphabets, spaces and dot (.) allowed";
        }
        break;

      case "dob":
        if (!value) {
          error = "Date of birth is required";
        } else {
          const dob = new Date(value);
          const today = new Date();
          let age = today.getFullYear() - dob.getFullYear();
          const monthDiff = today.getMonth() - dob.getMonth();

          if (
            monthDiff < 0 ||
            (monthDiff === 0 && today.getDate() < dob.getDate())
          ) {
            age--;
          }

          if (age < 18) {
            error = "Employee must be at least 18 years old";
          }
        }
        break;

      case "mobile":
        if (!value) {
          error = "Mobile number is required";
        } else if (!/^\d{10}$/.test(value)) {
          error = "Mobile number must be 10 digits";
        } else if (existingMobiles.includes(value)) {
          error = "Mobile number already exists";
        }
        break;

      case "email":
        if (!value) {
          error = "Email is required";
        } else if (
          !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value)
        ) {
          error = "Invalid email format";
        } else if (existingEmails.includes(value)) {
          error = "Email is already registered";
        }
        break;

      case "pin":
        if (!value) {
          error = "PIN code is required";
        } else if (!/^\d{6}$/.test(value)) {
          error = "PIN code must be exactly 6 digits";
        }
        break;

      case "manager":
        if (!value) {
          error = "Manager is required";
        }
        break;

      default:
        break;
    }

    return error;
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStateChange = async (e) => {
    const stateId = parseInt(e.target.value, 10) || null;

    setFormData((prev) => ({
      ...prev,
      state: stateId,
      manager: "",
      subState: "",
      city: "",
      headQuarter: "",
    }));

    if (!stateId) {
      setManagers([]);
      setSubStates([]);
      setCities([]);
      setHeadquarters([]);
      return;
    }

    // 🚨 IMPORTANT FIX
    if (!formData.designation) {
      toast.error("Please select designation first");
      return;
    }

    try {
      const token = localStorage.getItem("token");

      // ✅ MANAGERS (use axios)
      const mgrRes = await axios.get(
        `${BASE_URL}/api/managers-by-designation`,
        {
          params: {
            designation: formData.designation,
            state_id: stateId,
          },
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      const managersArray =
        mgrRes.data?.data || mgrRes.data?.managers || mgrRes.data || [];

      setManagers(managersArray);

      // ✅ SUB STATES
      const subRes = await axios.get(`${BASE_URL}/api/substates/${stateId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSubStates(subRes.data);

      // ✅ CITIES
      const cityRes = await axios.get(`${BASE_URL}/api/cities/${stateId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCities(cityRes.data);

      setHeadquarters([]);
    } catch (err) {
      console.error("State-based fetch error", err);
      toast.error("Failed to load state related data");
    }
  };
  const handleCityChange = async (e) => {
    const cityId = parseInt(e.target.value, 10) || null;

    setFormData((prev) => ({
      ...prev,
      city: cityId,
      headQuarter: "",
    }));

    if (!cityId) {
      setHeadquarters([]);
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const hqRes = await axios.get(`${BASE_URL}/api/headquarters/${cityId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const hqArray =
        hqRes.data?.data || hqRes.data?.headquarters || hqRes.data || [];

      setHeadquarters(hqArray);
    } catch (err) {
      console.error("City-based HQ fetch error", err);
      toast.error("Failed to load headquarters");
    }
  };
  // Handle headquarter change and fetch substates
  const handleHeadquarterChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      headQuarter: parseInt(e.target.value, 10) || null,
    }));
  };

  // Validate entire form
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    const requiredFields = [
      "username",
      "firstName",
      "dob",
      "mobile",
      "state",
      "city",
      "subState",
      "designation",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = "required";
        isValid = false;
      }
    });

    Object.keys(formData).forEach((key) => {
      if (errors[key] || newErrors[key]) return;

      const error = validateField(key, formData[key]);
      if (error) {
        newErrors[key] = error;
        isValid = false;
      }
    });

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return isValid;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    const formattedData = {
      employee: formData.username,
      first_name: formData.firstName,
      last_name: formData.lastName,
      father_name: formData.fatherName || null,
      dob: formData.dob || null,
      gender: formData.gender || null,
      email: formData.email,
      mobile: formData.mobile,
      manager: formData.manager || null,
      department: formData.department,
      division: formData.division,
      designation: formData.designation,
      address: formData.address || null,
      pin: formData.pin || null,
      country: formData.country,
      marriage_anniversary: formData.marriageAnniversary || null,
      final_joining_date: formData.finalJoiningDate || null,
      training_date: formData.trainingDate || null,
      confirm_date: formData.confirmDate || null,
      resign_date: formData.resignDate || null,
      remarks: formData.remarks || null,
      sms: "",
      status: "WORKING",
      state_id: parseInt(formData.state, 10),
      city_id: parseInt(formData.city, 10),
      headquarter_id: formData.headQuarter
        ? parseInt(formData.headQuarter, 10)
        : null,
      substate_id: parseInt(formData.subState, 10),
    };

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${BASE_URL}/api/employees`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formattedData),
      });

      if (!response.ok) {
        const errorData = await response.json();

        let message = "Something went wrong. Please try again.";

        if (errorData.detail?.includes("employees_mobile")) {
          message =
            "Mobile number already exists. Please use a different mobile number.";
        } else if (errorData.detail?.includes("employees_employee")) {
          message = "User ID already exists. Please choose another User ID.";
        } else if (errorData.detail?.includes("employees_email")) {
          message = "Email already exists. Please use another email.";
        }

        throw new Error(message);
      }

      toast.success("Employee added successfully");
      setFormData(initialFormState);
    } catch (error) {
      showErrorToast(error.message || "Failed to add employee");
    } finally {
      setIsSubmitting(false);
    }
  };
  // Bulk upload handlers
  const openBulkModal = () => setShowBulkModal(true);
  const closeBulkModal = () => {
    setShowBulkModal(false);
    setBulkFile(null);
  };

  const handleFileChange = (e) => {
    setBulkFile(e.target.files[0]);
  };

  const handleBulkUpload = async () => {
    if (!bulkFile) {
      showErrorToast("Please choose a file to upload");
      return;
    }

    setIsUploading(true);

    try {
      const form = new FormData();
      form.append("file", bulkFile);

      const token = localStorage.getItem("token");

      const response = await fetch(`${BASE_URL}/api/employees/bulk-upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: form,
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Bulk upload failed");
      }

      showSuccessToast(result.message || "Bulk upload successful");
      // reset and close modal
      setBulkFile(null);
      setShowBulkModal(false);
    } catch (err) {
      console.error("Bulk upload error:", err);
      showErrorToast(err.message || "Bulk upload failed");
    } finally {
      setIsUploading(false);
    }
  };
  return (
    <div className="addemployee-main-container">
      <Toaster />
      <div className="p-2  border-2 border-gray-300 rounded-lg bg-white">
        <div className=" flex justify-center">
          {/* Centered Heading */}
          <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
            <span className="text-blue-700">Add </span>
            <span className="text-blue-500">Employee</span>
          </h1>

          {/* Bulk upload button fixed to right corner */}
          <div className="absolute right-10">
            <CustomButton
              className="whitespace-nowrap"
              type="button"
              onClick={openBulkModal}
              variant="edit"
            >
              Upload
            </CustomButton>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <fieldset className=" border-2 border-gray-300 rounded-lg bg-gray-50 p-4">
            <legend className="bg-blue-500 border rounded text-white px-3">
              Basic Details
            </legend>
            <div className="grid-container">
              <label className="required-label">USER ID</label>
              <div className="input-field-container">
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  className={errors.username ? "input-error" : ""}
                />
                {errors.username && (
                  <span className="validation-error">{errors.username}</span>
                )}
              </div>

              <label className="required-label">FIRST NAME</label>
              <div className="input-field-container">
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  className={errors.firstName ? "input-error" : ""}
                />
                {errors.firstName && (
                  <span className="validation-error">{errors.firstName}</span>
                )}
              </div>

              <label className="required-label">LAST NAME</label>
              <div className="input-field-container">
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className={errors.lastName ? "input-error" : ""}
                />
                {errors.lastName && (
                  <span className="validation-error">{errors.lastName}</span>
                )}
              </div>

              <label className="required-label">FATHER NAME</label>
              <div className="input-field-container">
                <input
                  type="text"
                  name="fatherName"
                  value={formData.fatherName}
                  onChange={handleChange}
                  className={errors.fatherName ? "input-error" : ""}
                />
                {errors.fatherName && (
                  <span className="validation-error">{errors.fatherName}</span>
                )}
              </div>

              <label className="required-label">DIVISION</label>
              <select
                name="division"
                value={formData.division}
                onChange={handleChange}
              >
                <option value="">Select Division</option>
                {divisions.map((div) => (
                  <option key={div.id} value={div.name}>
                    {div.name}
                  </option>
                ))}
              </select>

              <label className="required-label">DESIGNATION</label>
              <select
                name="designation"
                value={formData.designation}
                onChange={handleChange}
                required
                className={errors.designation ? "input-error" : ""}
              >
                <option value="">Select Designation</option>
                {designations.map((des) => (
                  <option key={des.id} value={des.name}>
                    {des.name}
                  </option>
                ))}
              </select>
              <label className="required-label">STATE</label>
              <select
                name="state"
                value={formData.state}
                onChange={handleStateChange}
                required
              >
                <option value="">Select</option>
                {states.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.name}
                  </option>
                ))}
              </select>

              <label className="required-label">MANAGER</label>
              <select
                name="manager"
                value={formData.manager}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  Select Manager
                </option>

                {Array.isArray(managers) &&
                  managers.map((mgr) => (
                    <option key={mgr.employee_id} value={mgr.username}>
                      {mgr.first_name} {mgr.last_name} ({mgr.designation} |{" "}
                      {mgr.state_name} | {mgr.city_name})
                    </option>
                  ))}
              </select>

              <label className="required-label">SUB STATE</label>
              <select
                name="subState"
                value={formData.subState}
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                {subStates.map((sub) => (
                  <option key={sub.id} value={sub.id}>
                    {sub.name}
                  </option>
                ))}
              </select>

              <label>MARRIAGE ANNIVERSARY</label>
              <div className="marriage-anniversary-container">
                <input
                  type="date"
                  name="marriageAnniversary"
                  value={formData.marriageAnniversary}
                  onChange={handleChange}
                />
              </div>

              <label className="required-label">CITY</label>
              <select
                name="city"
                value={formData.city}
                onChange={handleCityChange}
                required
              >
                <option value="">Select</option>
                {cities.map((city) => (
                  <option key={city.id} value={city.id}>
                    {city.name}
                  </option>
                ))}
              </select>
              <label className="required-label">DEPARTMENT</label>
              <input type="text" name="department" value="SALES" readOnly />
              <label className="required-label">HEAD QUARTER</label>
              <select
                name="headQuarter"
                value={formData.headQuarter}
                onChange={handleHeadquarterChange}
              >
                <option value="">Select</option>
                {Array.isArray(headquarters) &&
                  headquarters.map((hq) => (
                    <option key={hq.id} value={hq.id}>
                      {hq.name}
                    </option>
                  ))}
              </select>
              <label className="required-label">COUNTRY</label>
              <input type="text" name="country" value="INDIA" readOnly />
              <label className="required-label">DOB</label>
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                required
                className={errors.dob ? "input-error" : ""}
                max={getEighteenYearsAgo()} 
              />

              {errors.dob && (
                <span className="validation-error">{errors.dob}</span>
              )}

              <label className="required-label">GENDER</label>
              <div style={{ display: "flex", gap: "10px" }}>
                <div className="flex gap-3 text-black">
                  <label className="flex items-center gap-1">
                    <input
                      type="radio"
                      name="gender"
                      value="Male"
                      checked={formData.gender === "Male"}
                      onChange={handleChange}
                    />
                    Male
                  </label>

                  <label className="flex items-center gap-1">
                    <input
                      type="radio"
                      name="gender"
                      value="Female"
                      checked={formData.gender === "Female"}
                      onChange={handleChange}
                    />
                    Female
                  </label>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset className=" border-2 border-gray-300 rounded-lg bg-gray-50 p-4 mt-2">
            <legend className="bg-blue-500 border rounded text-white px-3">
              Location Details
            </legend>
            <div className="grid-container">
              {/* <label className="required-label">STATE</label>
              <select
                name="state"
                value={formData.state}
                onChange={handleStateChange}
                required
                className={errors.state ? "input-error" : ""}
              >
                <option value="">Select</option>
                {states.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.name}
                  </option>
                ))}
              </select> */}

              {/* <label className="required-label">RESIDENTIAL STATE</label>
              <select
                name="residentialState"
                value={formData.residentialState}
                onChange={handleChange}
                required
                className={errors.residentialState ? "input-error" : ""}
              >
                <option value="">Select</option>
                {residentialStates.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.name}
                  </option>
                ))}
              </select> */}

              <label className="required-label" htmlFor="address">
                ADDRESS
              </label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter your address"
                className="w-full md:w-3/4 min-h-[40px] p-2 border border-gray-300 rounded"
              />

              <label className="required-label">PIN</label>
              <div className="input-field-container">
                <input
                  type="text"
                  id="pin"
                  name="pin"
                  value={formData.pin}
                  onChange={handleChange}
                  maxLength="6"
                  pattern="\d*"
                  title="PIN code must be 6 digits"
                  placeholder="Enter PIN code"
                  required
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/\D/g, ""))
                  }
                />

                {errors.pin && (
                  <span className="validation-error">{`PIN code must be 6 digits. Entered value: ${formData.pin}`}</span>
                )}
              </div>

              <label className="required-label">EMAIL</label>
              <div className="input-field-container">
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className={errors.email ? "input-error" : ""}
                  placeholder="Enter your email"
                />
                {errors.email && (
                  <span className="validation-error email-error">
                    {errors.email}
                  </span>
                )}
              </div>
              <label className="required-label">MOBILE</label>
              <div>
                <input
                  type="text"
                  id="mobile"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  maxLength="10"
                  pattern="\d*"
                  title="Mobile number must be 10 digits"
                  placeholder="Enter mobile number"
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/\D/g, ""))
                  }
                />
                {errors.mobile && (
                  <span className="error">{errors.mobile}</span>
                )}
              </div>
              <label>REMARKS</label>
              <textarea
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
              />
              <label className="required-label">FINAL JOINING DATE</label>
              <div className="input-field-container">
                <input
                  type="date"
                  name="finalJoiningDate"
                  value={formData.finalJoiningDate}
                  max="2099-12-31"
                  onChange={handleChange}
                  className={errors.finalJoiningDate ? "input-error" : ""}
                />
              </div>
            </div>
          </fieldset>

          <div className="flex items-center justify-center p-2">
            <CustomButton
              variant="save"
              onClick={handleSubmit}
              disabled={isSubmitting}
              style={{ width: "90px", height: "40px" }}
            >
              {isSubmitting ? (
                <div className="loader">Loading...</div>
              ) : (
                "Submit"
              )}
            </CustomButton>
          </div>
        </form>
      </div>

      {/* Bulk upload modal */}
      {showBulkModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black opacity-30"
            onClick={closeBulkModal}
          ></div>

          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 p-6">
            <div className="flex items-start justify-between">
              <h2 className="text-lg font-semibold">Bulk Upload Employees</h2>
              <button
                onClick={closeBulkModal}
                className="text-gray-500 hover:text-gray-800"
              >
                ✕
              </button>
            </div>

            <p className="text-sm text-gray-600 mt-2">
              Upload a CSV or Excel file. The file you select will be sent to
              the bulk upload endpoint.
            </p>

            <div className="mt-6 flex items-center gap-3">
              <input
                type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={handleFileChange}
                className="border border-gray-300 rounded"
              />
              <CustomButton
                variant="save"
                onClick={handleBulkUpload}
                disabled={isUploading}
                className="px-2 py-2 rounded disabled:opacity-60"
              >
                {isUploading ? "Uploading..." : "Upload"}
              </CustomButton>

              <CustomButton
                variant="cancel"
                onClick={closeBulkModal}
                className="px-4 py-2 border rounded"
              >
                Cancel
              </CustomButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddEmployeeForm;
